export default "__VITE_ASSET__CYH_Eg1l__"